var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prizes-2021-section"},[(_vm.place)?_c('Prizes2021SectionPlace',{attrs:{"place":_vm.place}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }